import { styleSheet } from './styles';
import * as Api from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';

interface IProps {
	className?: string;
	styles?: StyleDeclarationValue[];
	account: Api.IAccount;
}

export const AccountStatusIndicator: React.FC<IProps> = props => {
	const { className, styles, account } = props;
	const color = account?.usage?.statusColor || 'gray';
	let colorClass;

	switch (color) {
		case 'green':
			colorClass = styleSheet.accountStatusGreen;
			break;
		case 'orange':
			colorClass = styleSheet.accountStatusOrange;
			break;
		case 'red':
			colorClass = styleSheet.accountStatusRed;
			break;
		case 'yellow':
			colorClass = styleSheet.accountStatusYellow;
			break;
		default:
			colorClass = styleSheet.accountStatusGray;
			break;
	}

	return (
		<span
			className={`${css(styleSheet.adminAccountStatus, ...(styles || []))} ${css(colorClass)} ${className || ''}`}
		/>
	);
};
